var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"detailsCircle"},[_c('div',{staticClass:"detailsCircleContent"},[_c('detailsPersonal'),_c('div',{staticClass:"detailsDetails"},[_c('div',{staticClass:"detailsDetails_left"},[_c('detailsTheListOf')],1)])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }